<template>
    <div class="dialog" id="add-dialog" aria-hidden="true">
        <div class="dialog-overlay" tabindex="-1" data-a11y-dialog-hide></div>
        <div
            role="dialog"
            class="dialog-content"
            aria-labelledby="my-dialog-title"
            aria-describedby="my-dialog-description"
        >
            <button
                data-a11y-dialog-hide
                class="dialog-close"
                aria-label="Close this dialog window"
            >
                <img src="@/assets/icons/dialog-close.svg" width="24" height="24" :alt="$t('projects.add.dialog_close')" />
            </button>

            <div class="project-add loader-block-parent">
                <div v-show="isLoading" class="loader-block">
                    <div>
                        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                    </div>
                </div>
                <img src="@/assets/images/notes.png" height="155" width="158" :alt="$t('projects.add.img_notebooks')" />
                <p class="project-add__heading">
                    <template v-if="!addNewClient">{{ $t('projects.add.start') }}</template>
                    <template v-else="addNewClient">{{ $t('projects.add.add_investor') }}</template>
                </p>
                <form @submit.prevent="addNewProject">



                    <template v-if="addNewClient">
                       <div class="project-add__no-client-container">
                           <p class="close" @click="addNewClient = false">x</p>
                           <div class="project-add__no-client-container__row">
                               <div class="control control--input">
                                   <label for="firstName" class="control__label">{{ $t('projects.add.name') }}</label>
                                   <input
                                       type="text"
                                       id="firstName"
                                       :class="{'error': errors.firstName}"
                                       :placeholder="$t('projects.add.name_placeholder')"
                                       v-model="firstName"
                                   />
                                   <div v-show="errors.firstName" class="control__error">
                                       <div class="control__error-inner">
                                           {{errors.firstName}}
                                       </div>
                                   </div>
                               </div>
                               <div class="control control--input mb-20">
                                   <label for="lastName" class="control__label">{{ $t('projects.add.lastname') }}</label>
                                   <input
                                       type="text"
                                       id="lastName"
                                       :class="{'error': errors.lastName}"
                                       :placeholder="$t('projects.add.lastname_placeholder')"
                                       v-model="lastName"
                                   />
                                   <div v-show="errors.lastName" class="control__error">
                                       <div class="control__error-inner">
                                           {{errors.lastName}}
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <div class="project-add__no-client-container__row">
                               <div class="control control--input">
                                   <label for="phone" class="control__label">{{ $t('projects.add.phone') }}</label>
                                   <input
                                       type="phone"
                                       id="phone"
                                       :placeholder="$t('projects.add.phone_placeholder')"
                                       v-model="phone"
                                   />
                               </div>
                               <div class="control control--input mb-20">
                                   <label for="email" class="control__label">{{ $t('projects.add.email') }}</label>
                                   <input
                                       type="email"
                                       id="email"
                                       :class="{'error': errors.email}"
                                       :placeholder="$t('projects.add.email_placeholder')"
                                       v-model="email"
                                   />
                                   <div v-show="errors.email" class="control__error">
                                       <div class="control__error-inner">
                                           {{errors.email}}
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                    </template>


                    <div class="control control--input">
                        <label for="projectName" class="control__label">{{ $t('projects.add.project_name') }}</label>
                        <input
                            type="text"
                            id="projectName"
                            :placeholder="$t('projects.add.project_name_placeholder')"
                            v-model="projectName"
                            :class="{error: errors.projectName}"
                        />
                        <div v-show="errors.projectName" class="control__error">
                            <div class="control__error-inner">
                                {{errors.projectName}}
                            </div>
                        </div>
                    </div>
                    <div v-show="!addNewClient" class="project-add__no-client-btn">
                        <p>{{$t('projects.add.add_investor')}}</p>
                        <button type="button" @click="addNewClient = true;">
                            <img src="@/assets/icons/person-add.svg" width="16" height="16" alt="Dodaj" />
                            <p>{{$t('projects.add.add_investor_by_email')}}</p>

                        </button>
                    </div>
                    <template v-if="!addNewClient">
                        <select-search class="margin-0"
                           :data="clients"
                           v-model:selected-item="selectedClient"
                           :set-custom-label="(item) => item.firstName + ' ' + item.lastName"
                           :label="$t('projects.add.search_investors_title')"
                           :placeholder="$t('projects.add.search_investors_placeholder')"
                           :empty-result="$t('projects.add.search_investors_empty_result')"
                           :errors="errors.selectedClient"
                        />
                    </template>
                    <div class="project-add__button">
                        <button type="submit" :disabled="isSubmitting">
                            <template v-if="!addNewClient">{{ $t('projects.add.create_project') }}</template>
                            <template v-else="addNewClient">{{ $t('projects.add.add_investor_to_the_project') }}</template>
                        </button>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>

import SelectSearch from "@/components/fields/select/selectSearch";
import {onMounted, ref, reactive, watch, inject} from "vue";
import {useRouter} from "vue-router";
import {useClientsStore} from "@/stores/user/architect/clients.store";
import {storeToRefs} from "pinia";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import {useI18n} from "vue-i18n";
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import i18n from "@/i18n";
import AlertHelper from "@/helpsers/alert.helper";

export default {
    name: "addProjectModal",
    components: {
         SelectSearch
    },
    setup() {
        const addDialog = ref(),
            router = useRouter(),
            clientStore = useClientsStore(),
            {clients, isLoading} = storeToRefs(clientStore),
            phone = ref(''),
            errorMessage = ref(''),
            {t} = useI18n(),
            alert = inject('alert');

        onMounted(() => {
            addDialog.value = new A11yDialog(document.querySelector("#add-dialog"));
        });

        const { handleSubmit, errors, isSubmitting } = useForm({
            initialValues: {
                addNewClient: false,
            },
            validationSchema: yup.object().shape({
                addNewClient: yup.boolean(),
                email: yup.string()
                    .when('addNewClient', {
                        is: true,
                        then: schema => schema
                            .email(t('validate.email'))
                            .trim()
                            .required(t('validate.required'))
                    }),
                firstName: yup.string()
                    .when('addNewClient', {
                        is: true,
                        then: schema => schema
                            .trim()
                            .required(t('validate.required'))
                    }),
                lastName: yup.string()
                    .when('addNewClient', {
                        is: true,
                        then: schema => schema
                            .trim()
                            .required(t('validate.required'))
                    }),
                projectName: yup.string().trim().required(t('validate.required')),
                selectedClient: yup.object(),
            }
            ),
        });

        const { value: email } = useField('email');
        const { value: firstName } = useField('firstName');
        const { value: lastName } = useField('lastName');
        const { value: projectName } = useField('projectName');
        const { value: selectedClient } = useField('selectedClient');

        const { value: addNewClient } = useField('addNewClient');


        const addNewProject = handleSubmit(() => {
                let data = {
                    name: projectName.value,
                }

                if(addNewClient.value) {
                    const data1 = {
                        clientEmail: email.value,
                        clientFirstName: firstName.value,
                        clientLastName: lastName.value,
                        clientPhone: phone.value,
                    }
                    data = {...data, ...data1};
                }
                else {
                    const data2 = {
                        clientId: selectedClient.value?.id ?? 0
                    }
                    data = {...data, ...data2};
                }

                axios.post(ApiHelper.getAddProjectUrl(), data, {
                    headers: authHelper.authHeader()
                })
                    .then((result) => {
                        router.push({name: 'create-project-profile', params: {id: result.data.id}})
                    })
                    .catch((error) => {
                        errorMessage.value = ApiHelper.getResponseMessage(error.response?.data?.code);
                        AlertHelper.show(alert, errorMessage.value, '', 'error');
                    })
        });

        return {
            clients,
            isLoading,
            selectedClient,
            addNewClient,
            addNewProject,
            firstName,
            lastName,
            phone,
            email,
            errorMessage,
            projectName,
            errors,
            isSubmitting,
        }

    }

}
</script>

<style scoped lang="scss">
.margin-0 {
    margin: 0 !important;
}
.project-add {
    margin: 24px 0;
    form {
        position: relative;
    }
    &__no-client-btn {
        margin: 20px 0 20px 0;
        & > p {
            font: normal normal 400 1.5rem/15px Montserrat;
            margin-bottom: 12px;
            color: #353535;
        }
        button {
            width: 100%;
            cursor: pointer;
            padding:  16px 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #F2F2F2;
            &:hover {
                background: #E6E5E5;
            }
            border: 1px solid #D9D9D9;
            border-radius: 8px;
            p {
                font: normal normal 500 1.875rem/18px Montserrat;
                text-align: center;
                color: #8C8F94;
            }
            img {
                margin-right: 10px;
            }

        }
    }

    &__no-client-container {
        .close {
            cursor: pointer;
            position: absolute;
            right: 0;
            z-index: 1;
            &:hover {
                color: #9e5d57;
            }
        }
        &__row {
            display: flex;

            .control {
                &--input {
                    padding-right: 10px;
                }
            }
        }
    }

    &__button {
        margin-top: 50px;
        button {
            font: normal normal 500 1.875rem/18px Montserrat;
             cursor: pointer;
             a {
                 color: white;
             }

             &:hover {
                 background: #e35748;
             }
         }

    }
}
.error-message {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    color: red;
    font-weight: 500;

}

.mb-20 {
    margin-bottom: 20px;
}
</style>
